export function transmissionTextFormat(transmissionText: string) {
  return transmissionText
    ?.replaceAll('pFCPUFDest', 'Percentual ICMS FCP')
    .replaceAll('vBCUFDest', 'Base de Cálculo ICMS')
    .replaceAll('cEAN', 'Código de barra')
    .replaceAll('cEANTrib', 'Código de barra');
}
